/* Scroll animations disabled for debugging */
(function() {
  'use strict';
  // All animations disabled
  console.log('Eliase scroll animations: disabled');
})();
